const BrowserUtils = {};

BrowserUtils.innerWidth = function() {
  return window.innerWidth;
};

BrowserUtils.isDesktop = function() {
  return this.innerWidth() > 991;
};

BrowserUtils.pathname = function() {
  return window.location.pathname;
};

BrowserUtils.notifyNewMessage = function (conversation) {
  if (('Notification' in window) && !document.hasFocus() && this.isDesktop()) {
    var messageCreator = conversation.headlineMessage.creator;

    window.name = 'Voray Inbox';
    var type = conversation.participants.length > 2 ? 'group' : 'private';
    var displayMessage = 'New ' + type + ' message from ' + messageCreator.displayName;
    var notification = new Notification('Voray', {
      body: displayMessage,
      icon: messageCreator.headShotImage
    });

    notification.onshow = function () {
      window.setTimeout(() => { notification.close(); }, 6000);
    };

    notification.onclick = function () {
      var url = '/conversations/' + conversation.id + '/messages';
      window.open(url, 'Voray Inbox');
      window.focus();
      this.close();
    };
  }
};

export default BrowserUtils;
